(() => {
	const dropdown = document.querySelectorAll(".dropdown");
	const dropdownList = document.querySelectorAll(".dropdown-list");

	const active = (top) => {
		return ["visible", "opacity-100", "z-10", top];
	};

	const deActive = (top) => {
		return ["invisible", "opacity-0", "z-0", top];
	};

	if (dropdown && dropdownList) {
		// global click handler
		window.onclick = function (event) {
			if (
				!event.target.matches(".dropdown") &&
				!event.target.parentNode.matches(".dropdown") &&
				!event.target.parentNode.parentNode.matches(".dropdown") &&
				!event.target.parentNode.parentNode.parentNode.matches(
					".dropdown"
				)
			) {
				dropdownList.forEach((element) => {
					const { activeTop, deactiveTop } = element.dataset;
					element.classList.remove(...active(activeTop));
					element.classList.add(...deActive(deactiveTop));
				});
			}
		};

		dropdown.forEach((element) => {
			const { actionType } = element.dataset;
			if (actionType === "hover") {
				element.addEventListener("mouseenter", () => {
					const { targetElement } = element.dataset;
					const targetList = document.getElementById(targetElement);
					const { activeTop, deactiveTop } = targetList.dataset;

					dropdownList.forEach((element) => {
						const { activeTop, deactiveTop } = element.dataset;
						element.classList.remove(...active(activeTop));
						element.classList.add(...deActive(deactiveTop));
					});
					targetList.classList.remove(...deActive(deactiveTop));
					targetList.classList.add(...active(activeTop));
				});

				element.addEventListener("mouseleave", () => {
					const { targetElement } = element.dataset;
					const targetList = document.getElementById(targetElement);
					const { activeTop, deactiveTop } = targetList.dataset;

					targetList.classList.remove(...active(activeTop));
					targetList.classList.add(...deActive(deactiveTop));
				});
			} else {
				element.addEventListener("click", () => {
					const { targetElement } = element.dataset;
					const dropdown = document.getElementById(targetElement);
					const { activeTop, deactiveTop } = dropdown.dataset;

					dropdownList.forEach((item) => {
						const elementId = item.getAttribute("id");

						if (targetElement !== elementId) {
							item.classList.remove(...active(activeTop));
							item.classList.add(...deActive(deactiveTop));
						}
					});

					if (dropdown.classList.contains("visible")) {
						dropdown.classList.remove(...active(activeTop));
						dropdown.classList.add(...deActive(deactiveTop));
					} else {
						dropdown.classList.remove(...deActive(deactiveTop));
						dropdown.classList.add(...active(activeTop));
					}
				});
			}
		});
	}
})();
